import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from '../../_alert';
import { MemberService } from '../../services/jrni/member.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  submitted: boolean;
  member;
  hide: boolean = true;
  hideConfirmPassword: boolean = true;
  hideCurrentPassword: boolean = true;

  constructor(
    private alertService: AlertService,
    private translateService: TranslateService,
    private memberService: MemberService,
    private spinner: NgxSpinnerService
  ) { }

  // Initialise the form
  changePasswordForm: FormGroup = new FormGroup({
    current_password: new FormControl('', Validators.required),
    new_password: new FormControl('', Validators.required),
    confirm_new_password: new FormControl('', Validators.required)
  }, {
    validators: this.passwordsValidator('new_password', 'confirm_new_password')
  });

  get form() { return this.changePasswordForm.controls; }

  ngOnInit() {
    this.memberService.getMember().then(member => {
      this.member = member;
    });
  }


  // On input entry checks if email and confirm email match
  passwordsValidator(passwordKey: string, confirmPasswordKey: string,): ValidatorFn {
    return (group: FormGroup): { [key: string]: any } => {

      let password = group.controls[passwordKey];
      let confirmPassword = group.controls[confirmPasswordKey];
      const checkP = this.checkMissMatch(password, confirmPassword)
      const checkPV = this.invalidPassword(password)
      let returnValue = {}
      if (checkP) {
        returnValue["mismatch"] = true
      }
      if (checkPV) {
        returnValue["pattern"] = true
      }
      console.log(password, confirmPassword)
      return returnValue
    };
  }


  checkMissMatch(email, confirmEmail) {
    // If the email and confirm email inputs have data
    if (email.value.length > 0 && confirmEmail.value.length > 0) {
      // Check if the emails match
      if (email.value !== confirmEmail.value) {
        confirmEmail.setErrors({ mismatch: true });
        return true
      } else if (confirmEmail.errors && confirmEmail.errors.mismatch) {
        // If the errors object does not contain any other errors then set errors {} to null
        if (Object.keys(confirmEmail.errors).length == 1) {
          confirmEmail.setErrors(null);
        } else {
          // Delete the mismatch error from the object as we do not want to remove any other errors that exist in the {}
          delete confirmEmail.errors.mismatch;
        }
        return false;
      }
    }
  }

  invalidPassword(password) {
    if (password.value.length < 12) {
      this.setPasswordValid(false, password)
      return true
    }
    let validCheckCount = 0
    let regex = /[a-z]/gm
    if (password.value.match(regex)) {
      validCheckCount++
    }
    regex = /[A-Z]/gm
    if (password.value.match(regex)) {
      validCheckCount++
    }
    regex = /[0-9]/gm
    if (password.value.match(regex)) {
      validCheckCount++
    }
    regex = /[^A-Za-z0-9\s]/gm
    if (password.value.match(regex)) {
      validCheckCount++
    }
    console.log("validCheckCount", validCheckCount)
    if (validCheckCount >= 3) {
      this.setPasswordValid(true, password)
      return false
    } else {
      this.setPasswordValid(false, password)
      return true
    }
  }

  setPasswordValid(valid, password) {
    if (!valid) {
      password.setErrors({ pattern: true });
      return true
    } else if (password.errors && password.errors.pattern) {
      // If the errors object does not contain any other errors then set errors {} to null
      if (Object.keys(password.errors).length == 1) {
        password.setErrors(null);
      } else {
        // Delete the mismatch error from the object as we do not want to remove any other errors that exist in the {}
        delete password.errors.pattern;
      }
      return false;
    }
  }

  // Submit the form update
  onSubmit() {
    this.alertService.clear();
    this.submitted = true;
    this.spinner.show();
    if (this.changePasswordForm.invalid) {
      console.log("this.changePasswordForm", this.changePasswordForm)
      this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
      // Scroll to the top of the page if form is invalid
      this.scrollToTop();
      this.spinner.hide();
      return;
    } else {
      if (this.form.new_password.value === this.form.confirm_new_password.value) {
        sessionStorage.setItem("auth_token", localStorage.getItem("auth_token"))
        this.memberService.updatePassword(this.member, this.changePasswordForm.value).then(res => {
          this.alertService.success(this.translateService.instant('ACCOUNT.UPDATE_PASSWORD_SUCCESS'))
          this.scrollToTop();
          this.spinner.hide();
          // BB clears the localstorage value
          localStorage.setItem("auth_token", sessionStorage.getItem("auth_token"))
        }).catch((error: HttpErrorResponse) => {
          if (error['response'] && error['response'].data.details[0] === "current_password doesn't match existing password") {
            this.alertService.error(this.translateService.instant('ACCOUNT.CURRENT_PASSWORD_NO_MATCH'));
          } else {
            this.alertService.error(this.translateService.instant('ACCOUNT.UPDATE_PASSWORD_FAILED'))
          }
          this.scrollToTop();
          this.spinner.hide();
        });
      } else {
        this.alertService.warn(this.translateService.instant('ACCOUNT.PASSWORD_MATCH_ERR'));
        this.scrollToTop();
        this.spinner.hide();
      }
    }
  }

  // Scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }
}
